export const REGISTER_FLOW = 'register';
export const LOGIN_FLOW = 'login';
